export const apiUrl = "https://yorkshirespudsapi.waepos.com/";
export const adminUrl = "https://yorkshirespudsadmin.waepos.com/";
